/* eslint-disable no-console */
/* eslint-disable no-undef */
import { applyMiddleware, combineReducers, createStore } from "redux"

import { composeWithDevTools } from "redux-devtools-extension"
import { combineEpics, createEpicMiddleware } from "redux-observable"

import CONSTANTS from "../assets/js/Constants"
import translate from "../translate/translate"
import accountEpic from "./epics/accountEpic"
import calendarMantananceConfigEpic from "./epics/calendar_mantanance_config_epic"
import calendarReminderConfigEpic from "./epics/calendar_reminder_config_epic"
import menuEpic from "./epics/menu_epic"
import systemEpic from "./epics/systemEpic"
import transportationEpic from "./epics/transportationEpic"
import baoTriEpic from "./epics/bao_tri_epic"
import calendarEpic from "./epics/calendar_epic"
import phutungEpic from "./epics/phu_tung_epic"
import tireEpic from "./epics/tire_epic"

import fuelChangeEpic from './epics/fuel_change_epic'
import normConfigurationEpic from './epics/norm_configuration_epic'
import fuelChangeReportEpic from './epics/fuel_change_report_epic'
import generalFuelReportEpic from './epics/general_fuel_report_epic'
import maintainanceReportEpic from './epics/maintainance_report_epic'

const epics = combineEpics(
   accountEpic.getBieuDo1,
   accountEpic.getBieuDo4,
   accountEpic.getGraphPriceTimeTransportationByTime,
   accountEpic.getStatisticalReminderByTime,
   accountEpic.setAccountEpic,
   accountEpic.updateUsersTransferance,
   accountEpic.transferUser,
   systemEpic.getTypeTransportation,
   systemEpic.getFormTransportation,
   systemEpic.getTypeFuelTransportation,
   systemEpic.reloadRegistraionPaper,
   systemEpic.reportFeeTransportationEpic,
   transportationEpic.searchTransportationEpic,
   transportationEpic.searchTransportationByTypeEpic,
   transportationEpic.getDetailTransportationEpic,
   transportationEpic.updateTransportationInfomation,
   transportationEpic.deleteTransportation,
   transportationEpic.postTransportationInfomation,
   transportationEpic.getDocumentsRegistrationPaper,
   transportationEpic.getRegistrationPaperDetail,
   transportationEpic.addRegistrationPaper,
   transportationEpic.updateRegistrationPaper,
   transportationEpic.deleteRegistrationPaper,
   transportationEpic.getInsurancePaper,
   transportationEpic.getInsurancePaperDetail,
   transportationEpic.addInsurancePaper,
   transportationEpic.updateInsurancePaper,
   transportationEpic.deleteInsurancePaper,
   transportationEpic.getCarBadgesPaper,
   transportationEpic.getCarBadgesPaperDetail,
   transportationEpic.addCarBadgesPaper,
   transportationEpic.updateCarBadgesPaper,
   transportationEpic.deleteCarBadgesPaper,
   transportationEpic.getRegistrationCardPaper,
   transportationEpic.getRegistrationCardPaperDetail,
   transportationEpic.addRegistrationCardPaper,
   transportationEpic.updateRegistrationCardPaper,
   transportationEpic.deleteRegistrationCardPaper,
   transportationEpic.getMaintenanceTransportation,
   transportationEpic.getMaintenanceTransportationDetail,
   transportationEpic.getIncidentTransportation,
   transportationEpic.getIncidentTransportationDetail,
   transportationEpic.getTodoIncidentTransportation,
   transportationEpic.addIncidentTransportationEpic,
   transportationEpic.updateIncidentTransportationEpic,
   transportationEpic.proccessIncidentTransportation,
   transportationEpic.getCalendarReminderTransportation,
   transportationEpic.getCalendarReminderTransportationDetail,
   transportationEpic.getTodoCalendarReminderTransportation,
   transportationEpic.getUserAndMaintananceProviderCalendarReminderTransportation,
   transportationEpic.updateCalendarReminderTransportationEpic,
   transportationEpic.cancleCalendarReminder,
   transportationEpic.getCostTransportation,
   transportationEpic.updateCostTransportation,
   transportationEpic.addCostTransportation,
   transportationEpic.deleteCostTransportation,
   transportationEpic.deleteCostTransportation,
   transportationEpic.getCostTransportationDetail,
   transportationEpic.getDocumentsRoadFee,
   transportationEpic.getRoadFeeDetail,
   transportationEpic.addRoadFee,
   transportationEpic.updateRoadFee,
   transportationEpic.deleteRoadFee,
   calendarMantananceConfigEpic.getListForCalendarMaintananceConfig,
   calendarMantananceConfigEpic.getCalendarMaintananceConfig,
   calendarMantananceConfigEpic.updateCalendarMaintananceConfig,
   calendarMantananceConfigEpic.checkExistedCalendarMaintananceConfig,
   // get_km_begin_end
   calendarMantananceConfigEpic.getKmBeginEnd,
   calendarReminderConfigEpic.updateCalendarDocumentConfig,
   calendarReminderConfigEpic.updateCalendarMaintananceConfig,
   menuEpic.getAllTodoList,
   menuEpic.getTodoDetail,
   menuEpic.updateTodo,
   menuEpic.addTodo,
   menuEpic.deleteTodo,
   menuEpic.getAllFormList,
   menuEpic.LayDanhMucBaoDuong,
   menuEpic.LayChiTietDanhMucBaoDuong,
   menuEpic.AddBaoDuong,
   menuEpic.UpdateBaoDuong,
   menuEpic.DeleteBaoDuong,
   menuEpic.LayDanhSachTrungTamDangKiem,
   menuEpic.LayChiTietDanhSachTrungTamDangKiem,
   menuEpic.AddTrungTamDangKiem,
   menuEpic.UpdateTrungTamDangKiem,
   menuEpic.DeleteTrungTamDangKiem,
   menuEpic.LayDanhSachNhaCungCapBaoHiem,
   menuEpic.LayChiTietBaoHiem,
   menuEpic.AddBaoHiem,
   menuEpic.UpdateBaoHiem,
   menuEpic.DeleteBaoHiem,
   menuEpic.LayDanhSachNhaCungCapPhuHieu,
   menuEpic.LayChiTietPhuHieu,
   menuEpic.AddPhuHieu,
   menuEpic.UpdatePhuHieu,
   menuEpic.DeletePhuHieu,
   menuEpic.LayDanhSachNhaCungCapDangKyXe,
   menuEpic.LayChiTietDangKyXe,
   menuEpic.AddDangKyXe,
   menuEpic.UpdateDangKyXe,
   menuEpic.DeleteDangKyXe,
   menuEpic.LayDanhSachTaiXe,
   menuEpic.LayChiTietTaiXe,
   menuEpic.ThemMoiTaiXe,
   menuEpic.GetListPhuTung,
   menuEpic.ThemMoiPhuTung,
   menuEpic.LayChiTietPhuTung,
   menuEpic.CapNhatPhuTung,
   baoTriEpic.LayThongTinBaoTri,
   baoTriEpic.CapNhatThongTinBaoTri,
   baoTriEpic.ThemMoiThongTinBaoTri,
   baoTriEpic.XoaThongTinBaoTri,
   calendarEpic.GetAllCalendarByTime,
   // phutungEpic.GetListPhuTung,
   // phutungEpic.SearchPhuTung,
   // phutungEpic.ThemMoiPhuTung,
   // phutungEpic.CapNhatPhuTung,
   phutungEpic.XoaPhuTung,
   tireEpic.SearchLopxe,
   tireEpic.ThemLopxe,
   tireEpic.CapNhatLopxe,
   tireEpic.XoaLopxe,
   tireEpic.GetDetailPhuongtien,
   tireEpic.GetListPhuongtien,
   tireEpic.GetListPhutung,

   fuelChangeEpic.getFuelTypeList,
   fuelChangeEpic.getLocationList,
   fuelChangeEpic.getVehiclesList,
   fuelChangeEpic.getDriverList,
   fuelChangeEpic.getViewDetailAction,
   fuelChangeEpic.postSearchAction,
   fuelChangeEpic.postInsertFuelChange,
   fuelChangeEpic.postUpdateFuelChange,
   fuelChangeEpic.getDeleteFuelChange,

   normConfigurationEpic.postVehicleList,
   normConfigurationEpic.getVehicleGroups,
   normConfigurationEpic.getVehicleSettings,
   normConfigurationEpic.postSaveAction,
   normConfigurationEpic.getDeleteAction,

   fuelChangeReportEpic.postVehicleList,
   fuelChangeReportEpic.postReportDataAction,
   fuelChangeReportEpic.postDownloadReportAction,

   generalFuelReportEpic.getVehicleGroups,
   generalFuelReportEpic.getVehicleByGroup,
   generalFuelReportEpic.postReportExtendDataAction,
   generalFuelReportEpic.postDownloadExtendReportAction,

   maintainanceReportEpic.postVehicleList,
   maintainanceReportEpic.getMaintainanceWorks,
   maintainanceReportEpic.getVendorSupplies,
   maintainanceReportEpic.postReportDataAction,
   maintainanceReportEpic.postDownloadReportAction
)

const epicMiddleware = createEpicMiddleware()
const reducers = combineReducers(CONSTANTS.REDUCERS)

const store = createStore(reducers, composeWithDevTools(applyMiddleware(epicMiddleware)))
epicMiddleware.run(epics)

store.subscribe(() => {
   const state = store.getState()
   // console.log("State of REDUX STORE :", state)
   if (state.system.scrollTop) {
      window.scrollTo(0, 0)
   }

   CONSTANTS.FUNCTION.COMMON.isShowDashBoard(state.system.isShowDashBoard)
   translate.changeLanguage(state.system.language.key)
})
export default store
